/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import { CompanyServicesFragmentFragmentDoc } from './companyServicesFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type Marketing_Support_Enum =
  | 'FURNITURE'
  | 'OTHER'
  /** English acronym for 'PLV' */
  | 'POS';

export type Minimum_Order_Value_Type_Enum =
  | 'PACKAGING'
  | 'PRICE'
  | 'WEIGHT';

export type Return_Policy_Enum =
  | 'FULL'
  | 'PARTIAL';

export type Social_Tag_Type_Enum =
  | 'ENGAGED_STORE'
  | 'GUARANTEED_SALES'
  | 'HIDDEN_GEM'
  | 'HIGHLY_RESPONSIVE'
  | 'HIGH_MARGIN'
  | 'NEW_ARRIVAL'
  | 'POPULAR'
  | 'TREND';

export type GetChannelSupplierInfoMessageDataQueryVariables = Exact<{
  supplierId: string;
  buyerId: string;
}>;


export type GetChannelSupplierInfoMessageDataQuery = { supplier: { id: string, tradeName: string, is_wholesaler: boolean, provide_marketing: boolean | null, marketing_details: string | null, provide_animation: boolean | null, animation_details: string | null, provide_electrical_appliance: boolean | null, electrical_appliance_details: string | null, provide_return_policy: boolean | null, return_policy: Types.Return_Policy_Enum | null, return_policy_details: string | null, provide_merchandising: boolean | null, merchandising_details: string | null, photos: Array<{ photo: { path: string, domain: string | null } }>, addresses: Array<{ latitude: number, longitude: number }>, products: Array<{ sub_family: string }>, products_aggregate: { aggregate: { max: { sub_family: string | null } | null } | null }, delivery_zones: Array<{ minimum_order_value: number, minimum_order_value_type: Types.Minimum_Order_Value_Type_Enum, negotiable_minimum_order_value: boolean, delivery_time: number | null, administrative_areas: Array<{ area: string }> }>, social_tags: Array<{ type: Types.Social_Tag_Type_Enum, priority: number, level: number, values: { [key: string]: any } | null }>, marketing_supports: Array<{ support: Types.Marketing_Support_Enum }> } | null, buyer: { addresses: Array<{ latitude: number, longitude: number, administrativeAreaLevel2: string | null }> } | null };


export const GetChannelSupplierInfoMessageDataDocument = /*#__PURE__*/ gql`
    query GetChannelSupplierInfoMessageData($supplierId: uuid!, $buyerId: uuid!) {
  supplier: company_by_pk(id: $supplierId) {
    id
    tradeName
    is_wholesaler
    photos {
      photo {
        path
        domain
      }
    }
    addresses {
      latitude
      longitude
    }
    products(distinct_on: sub_family) {
      sub_family
    }
    products_aggregate {
      aggregate {
        max {
          sub_family
        }
      }
    }
    delivery_zones {
      minimum_order_value
      minimum_order_value_type
      negotiable_minimum_order_value
      delivery_time
      administrative_areas {
        area
      }
    }
    social_tags(where: {base_unit_sku: {_is_null: true}}) {
      type
      priority
      level
      values
    }
    ...companyServicesFragment
  }
  buyer: company_by_pk(id: $buyerId) {
    addresses {
      latitude
      longitude
      administrativeAreaLevel2
    }
  }
}
    ${CompanyServicesFragmentFragmentDoc}`;

/**
 * __useGetChannelSupplierInfoMessageDataQuery__
 *
 * To run a query within a React component, call `useGetChannelSupplierInfoMessageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChannelSupplierInfoMessageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChannelSupplierInfoMessageDataQuery({
 *   variables: {
 *      supplierId: // value for 'supplierId'
 *      buyerId: // value for 'buyerId'
 *   },
 * });
 */
export function useGetChannelSupplierInfoMessageDataQuery(baseOptions: Apollo.QueryHookOptions<GetChannelSupplierInfoMessageDataQuery, GetChannelSupplierInfoMessageDataQueryVariables> & ({ variables: GetChannelSupplierInfoMessageDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChannelSupplierInfoMessageDataQuery, GetChannelSupplierInfoMessageDataQueryVariables>(GetChannelSupplierInfoMessageDataDocument, options);
      }
export function useGetChannelSupplierInfoMessageDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChannelSupplierInfoMessageDataQuery, GetChannelSupplierInfoMessageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChannelSupplierInfoMessageDataQuery, GetChannelSupplierInfoMessageDataQueryVariables>(GetChannelSupplierInfoMessageDataDocument, options);
        }
// @ts-ignore
export function useGetChannelSupplierInfoMessageDataSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChannelSupplierInfoMessageDataQuery, GetChannelSupplierInfoMessageDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetChannelSupplierInfoMessageDataQuery, GetChannelSupplierInfoMessageDataQueryVariables>;
export function useGetChannelSupplierInfoMessageDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChannelSupplierInfoMessageDataQuery, GetChannelSupplierInfoMessageDataQueryVariables>): Apollo.UseSuspenseQueryResult<GetChannelSupplierInfoMessageDataQuery | undefined, GetChannelSupplierInfoMessageDataQueryVariables>;
export function useGetChannelSupplierInfoMessageDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChannelSupplierInfoMessageDataQuery, GetChannelSupplierInfoMessageDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChannelSupplierInfoMessageDataQuery, GetChannelSupplierInfoMessageDataQueryVariables>(GetChannelSupplierInfoMessageDataDocument, options);
        }
export type GetChannelSupplierInfoMessageDataQueryHookResult = ReturnType<typeof useGetChannelSupplierInfoMessageDataQuery>;
export type GetChannelSupplierInfoMessageDataLazyQueryHookResult = ReturnType<typeof useGetChannelSupplierInfoMessageDataLazyQuery>;
export type GetChannelSupplierInfoMessageDataSuspenseQueryHookResult = ReturnType<typeof useGetChannelSupplierInfoMessageDataSuspenseQuery>;
export type GetChannelSupplierInfoMessageDataQueryResult = Apollo.QueryResult<GetChannelSupplierInfoMessageDataQuery, GetChannelSupplierInfoMessageDataQueryVariables>;